<template>
  <div>
    <menu-pae :inFocus="false">
      <menu-processo :numeroProcesso="numeroProcesso" :apensado="apensado"/>
    </menu-pae>
    <iframe :src="urlVirtus" style="width: 100vw;height: 100vh;"/>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import menuProcesso from '@/components/MenuProcesso.vue'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'
import NumeroProcessoService from '@/services/NumeroProcessoService'
import VirtusService from '@/services/VirtusService'

import { mapState } from 'vuex'

export default {
  name: 'documento',

  components: {
    menuPae,
    menuProcesso
  },

  computed: mapState({
    objetoVirtus: state => {
      // console.log('Statee', state)
      return {
        numeroProcesso: state.documento.numeroProtocolo,
        chaveCategoria: 'EXTERNO',
        aplicacao: 'pae',
        chaveCliente: '8a5d2a69100565ce1fda08d6e4136884',
        protocolo: state.documento.protocolo,
        processoModelo: state.isVisible.protocoloTipoProcesso ? 'processo' : 'documentoAvulso',
        usuarioSessao: {
          nome: state.dadosSessao.sessao.nomeUsuario,
          identificador: state.dadosSessao.sessao.login,
          tipoIdentificador: 'LOGIN',
          participantePai: {
            nome: state.dadosSessao.sessao.descricaoDepartamento,
            identificador: state.dadosSessao.sessao.idDepartamento,
            tipoIdentificador: 'ID',
            participantePai: {
              nome: state.dadosSessao.sessao.descricaoOrgao,
              identificador: state.dadosSessao.sessao.idOrgao,
              tipoIdentificador: 'ID'
            }
          }
        }
      }
    }
  }),

  watch: {
    objetoVirtus: function () {
      this.criarAcesso()
    }
  },

  data () {
    return {
      urlVirtus: '',
      numeroProcesso: ''
    }
  },

  created () {
    this.processoElaboracaoService = new ProcessoElaboracaoService()
    this.numeroProcessoService = new NumeroProcessoService()
    this.virtusService = new VirtusService()
    this.numeroProcesso = this.$route.params.numeroProcesso
    this.protocolo = this.$route.params.protocolo
    this.apensado = this.$route.query.apensado

    this.criarAcesso()
  },

  methods: {
    criarObjetoVirtus (dadosSessao) {
      return {
        numeroProcesso: this.numeroProcesso,
        chaveCategoria: 'EXTERNO',
        aplicacao: 'pae',
        chaveCliente: '8a5d2a69100565ce1fda08d6e4136884',
        protocolo: this.protocolo,
        usuarioSessao: {
          nome: dadosSessao.sessao.nomeUsuario,
          identificador: dadosSessao.sessao.login,
          tipoIdentificador: 'LOGIN',
          participantePai: {
            nome: dadosSessao.sessao.descricaoDepartamento,
            identificador: dadosSessao.sessao.idDepartamento,
            tipoIdentificador: 'ID',
            participantePai: {
              nome: dadosSessao.sessao.descricaoOrgao,
              identificador: dadosSessao.sessao.idOrgao,
              tipoIdentificador: 'ID'
            }
          }
        }
      }
    },

    criarAcesso () {
      const dadosVirtus = this.objetoVirtus
      this.virtusService.criarAcesso(dadosVirtus).then(result => {
        this.urlVirtus = result.url
      })
    }
  }
}
</script>

<style scoped>

</style>
